import { Box, Button, Skeleton, Typography } from "@mui/material";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import { useEffect } from 'react';
import axios from 'axios';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import veg from "../Assets/product_management/Foodmark.svg"
import nonVeg from "../Assets/product_management/non-veg.svg"
import { updateInventoryDetail, updateInventoryDetailsModal, updateInventryHubsupervisors, updateSelectedInventoryId, updateallInventryDetails, updateinventoryDetailsEdit } from "../Redux/inventory";
import { useState } from "react";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import Tooltip from '@mui/material/Tooltip';
import CustomAxios from "../utils/CustomAxios";
import { useDateformate, useGetInventoryDetails, useGetProducts } from "../Components/globalFunctions";
import { useNavigate } from "react-router-dom";
import { updatepageName } from "../Redux/page";
import VisibilityIcon from '@mui/icons-material/Visibility';

export function InventoryDetailsTable() {
    const authToken = localStorage.getItem('authtoken');
    const toast = useRef(null);
    const products = useSelector(state => state.products.products)
    const edit = useSelector(state => state.inventory.inventoryDetailsEdit)
    const search = useSelector(state => state.page.searchProduct)
    const product_search = useSelector(state => state.inventory.inventoryProductSearch)
    // const inventoryDetails = useSelector(state => state.inventory.inventory_detail)
    const inventoryDetails = useSelector(state => state.inventory.allInventryDetails)
    const inventories = useSelector(state => state.inventory.inventory)
    const supervisors = useSelector(state => state.inventory.supervisors)
    const [details, setDetails] = useState([])
    const getInventeroryDetails = useGetInventoryDetails()
    const getProducts = useGetProducts()
    const inventoryDetailsLoading  = useSelector(state => state.inventory.inventoryDetailsLoading);
    const dateFormat = useDateformate()
    const dispatch = useDispatch();
    const navigate = useNavigate()
   
    useEffect(() => {
        if (inventoryDetails && inventoryDetails.length > 0 && (!products || products.length === 0)) {
            getProducts();
        }
    }, [inventoryDetails, products, getProducts]);

    useEffect(() => {
        if (!inventoryDetails || inventoryDetails.length === 0) {
            setDetails([]);
            return;
        }

        let filtered = [];
        const updatedInventoryDetails = inventoryDetails.map((inventory) => {
            const productMatch = products && products.length > 0 
                ? products.find(p => (p.value === inventory.product_id) || (p.id === inventory.product_id))
                : null;
            
            if (productMatch) {
                if (inventories && inventories.length > 0) {
                    filtered = inventories.filter((item) => item.name == inventory.place);
                }
                
                const productImages = productMatch.images || productMatch.image_urls || productMatch.images_read || [];
                const productImageUrls = productMatch.image_urls || productMatch.images || [];
                const imagesArray = Array.isArray(productImages) ? productImages : (productImages ? [productImages] : []);
                const imageUrlsArray = Array.isArray(productImageUrls) ? productImageUrls : (productImageUrls ? [productImageUrls] : []);
                const allImages = imageUrlsArray.length > 0 ? imageUrlsArray : imagesArray;
                
                return {
                    ...inventory,
                    images: allImages.length > 0 ? allImages : (Array.isArray(inventory.images) ? inventory.images : (inventory.images ? [inventory.images] : [])),
                    image_urls: imageUrlsArray.length > 0 ? imageUrlsArray : (Array.isArray(inventory.image_urls) ? inventory.image_urls : (inventory.image_urls ? [inventory.image_urls] : [])),
                    item_name: productMatch.item_name || inventory.item_name || inventory.product?.item_name,
                    item_category: productMatch.item_category || inventory.item_category || inventory.product?.item_category,
                    item_criteria: productMatch.item_criteria || inventory.item_criteria || inventory.product?.item_criteria,
                };
            }
            
            const existingImages = inventory.images || inventory.image_urls || [];
            const imagesArray = Array.isArray(existingImages) ? existingImages : (existingImages ? [existingImages] : []);
            const existingImageUrls = inventory.image_urls || [];
            const imageUrlsArray = Array.isArray(existingImageUrls) ? existingImageUrls : (existingImageUrls ? [existingImageUrls] : []);
            
            return {
                ...inventory,
                images: imagesArray,
                image_urls: imageUrlsArray,
                item_name: inventory.item_name || inventory.product?.item_name || 'Product',
                item_category: inventory.item_category || inventory.product?.item_category || '',
                item_criteria: inventory.item_criteria || inventory.product?.item_criteria || '',
            };
        });

        if (inventoryDetails.length > 0 && supervisors?.length > 0 && filtered?.length > 0) {
            const commonNames = supervisors
                .filter(obj1 => filtered[0].supervisors?.some(obj2 => obj1.id === obj2.id))
                .map(obj => obj.name);
            dispatch(updateInventryHubsupervisors(commonNames));
        }

        setDetails(updatedInventoryDetails);
    }, [inventoryDetails, products, inventories, supervisors, dispatch]);

  
console.log("--------------->>>",details.length,inventoryDetailsLoading);

    return (<Box>
        <Toast ref={toast} />
        <Typography sx={{fontSize: "16px", fontWeight: "700", lineHeight: "24px"}}>Inventory Details List</Typography>
        <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S No</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Images</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Place</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Products</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Capacity In Stock</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Availability</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Date added</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Expiry Date</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Total Units</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="right">Category</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="right">Criteria</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="right">BoGo</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Actions</TableCell>


                    </TableRow>
                </TableHead>
                <TableBody>
                    {details?.length>0?
                    details?.filter((item) => {
                        const itemName = item.item_name || item.product?.item_name || '';
                    
                        return product_search !== ""
                          ? itemName.toLowerCase().includes(product_search?.toLowerCase())
                          : true; })?.map((item,ind) => {
                        if (ind === 0) {
                            console.log('First item image data:', {
                                images: item.images,
                                image_urls: item.image_urls,
                                product_id: item.product_id
                            });
                        }
                        return (<> {
                            <TableRow key={item.id}>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{ind+1}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} onClick={() => (navigate("/home/inventoryBatchList"), dispatch(updatepageName("inventoryBatchList")))}>
                                {((item?.images && item.images.length > 0) || (item?.image_urls && item.image_urls.length > 0)) 
                                    ? (item?.image_urls || item?.images || []).map((img, imgIdx) => (
                                        img ? <Box key={imgIdx} component='img' src={img} alt={item.item_name || 'Product'} sx={{ width: "40px", height: "40px", borderRadius: "8px", marginRight: "10px", objectFit: "cover" }} onError={(e) => { e.target.style.display = 'none'; }}></Box> : null
                                    ))
                                    : <Typography sx={{ fontSize: "12px", color: "#999" }}>No image</Typography>
                                }
                                </TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.place || 'N/A'}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.item_name || item.product?.item_name || 'Product'}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.available_units+" "+(item.units=="kilogram"?"Kg":item.units=="litre"?"Ltr":item.units=="grams"?"gms":"")}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.available_units == 0 ?<Box sx={{ width:"120px",height:"22px",backgroundColor:"button.backgroundDelete",border:"1px solid",borderColor:"borders.red",borderRadius:"2px",padding:"1px 8px" ,display:"flex",justifyContent:"center"}}><Typography sx={{fontSize:"12px",fontWeight:400,lineHeight:"20px",color:"borders.red",textAlign:"center",textTransform:"uppercase", width:"88px"}}> out of stock</Typography></Box>:<Box sx={{ width:"67px",height:"22px",backgroundColor:"button.backgroundEdit",border:"1px solid",borderColor:"borders.green" ,borderRadius:"2px",padding:"1px 8px",display:"flex",justifyContent:"center"}} ><Typography sx={{textAlign:"center",fontSize:"12px",fontWeight:400,lineHeight:"20px",color:"borders.green",textTransform:"uppercase",width:"67px"}}>instock</Typography></Box>}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{dateFormat(item.created_on)}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{dateFormat(item.expired_on)}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.total_units}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.item_category}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.item_criteria == 'veg' ? <Box component='img' src={veg}></Box> : <Box component='img' src={nonVeg}></Box>}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item?.offer?.length > 0 ? <Box sx={{ width: "67px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green", borderRadius: "2px", padding: "1px 8px", display: "flex", justifyContent: "center" }} ><Typography sx={{ textAlign: "center", fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green", textTransform: "uppercase", width: "67px" }}>BOGO</Typography></Box>:'-- --'}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white", display: "flex",gap:"8px",alignItems:"center"}}>
                                <Tooltip title="View inventory batches" arrow>
                                        <IconButton sx={{ textTransform: "none" }} onClick={() => (navigate("/home/inventoryBatchList"), dispatch(updatepageName("inventoryBatchList")), dispatch(updateSelectedInventoryId(item)))}><VisibilityIcon /></IconButton>
                                </Tooltip>
                                </TableCell>
                            </TableRow>}</>)
                    })
                    : <TableRow  >
                    {inventoryDetailsLoading?<TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white",height:"200px",fontWeight:"700" }} colSpan={12}>
                        <Box>
                            <Box sx={{ width: "80%" }}>
                                <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                                <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                            </Box>
                            <Box sx={{ width: "80%" }}>
                                <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                                <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                            </Box>
                            <Box sx={{ width: "80%" }}>
                                <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                                <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                            </Box>
                        </Box>
                    </TableCell>:
                                <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: "200px", fontWeight: "700" }} colSpan={12}>No Inventory Details Available</TableCell>}
                </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Box>)
}